import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import NotificationEventTypes from "../../constants/notificationEventsEnum";

function WithdrawalConfirmationModal({
  onClose,
  studentId,
  withdrawalId,
  refreshOnSubmitSuccess,
}) {
  const token = localStorage.getItem("token");
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    formState: { errors, isSubmitting },
    handleSubmit,
    reset,
    getValues,
  } = useForm();

  useEffect(() => {
    handleDepartmentTabClick(departments[0].key);
  }, []);

  const departments = [
    { key: "Library", value: "Library", id: 52 },
    { key: "IT", value: "IT", id: 53 },
    { key: "Transport", value: "Transport", id: 54 },
    { key: "Academic", value: "Academic", id: 55 },
    { key: "Accounts", value: "Accounts", id: 56 },
    // { key: "Activity", value: "Activity", id: 57 },
  ];

  const [activeTab, setActiveTab] = useState(departments[0].key);
  const [tabData, setTabData] = useState({});

  const handleDepartmentTabClick = async (departmentName) => {
    setActiveTab(departmentName);
    if (tabData[departmentName]) return;

    try {
      const response = await get(
        `Withdrawal/GetDepartmentIssuedData?departmentName=${departmentName}&studentId=${studentId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess) {
        setTabData((prev) => ({
          ...prev,
          [departmentName]: response.departmentIssuedData,
        }));
      } else {
        toast.error("Error fetching issued items data.");
      }
    } catch (error) {
      console.error("Error fetching issued items data:", error);
      toast.error("An error occurred while fetching issued items data.");
    }
  };

  const saveWithdrawalConfirmation = async (data) => {
    setIsLoading(true);
    const formData = {
      withdrawalId: withdrawalId,
      submissionDate: new Date().toISOString(),
      remarks: data.remarks,
      studentFirstRegistrationId: studentId,
      FormId: 59,
      NotificationEventTypeIds: NotificationEventTypes.CONFIRMATION.toString(),
    };
    // console.log(formData);
    // return;
    try {
      const response = await post(
        "Withdrawal/AddWithdrawalSubmissionDate",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        onClose();
        refreshOnSubmitSuccess();
      } else {
        toast.error("Failed.");
      }
    } catch (error) {
      console.error("Error saving:", error);
      toast.error("An error occurred while saving.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="mb-0">Withdrawal Confirmation</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body">
              <div
                className="tab-content mt-3"
                id="departmentTabsContent"
              ></div>

              <form
                className="row g-3"
                onSubmit={handleSubmit(saveWithdrawalConfirmation)}
              >
                <div className="col-md-12">
                  <label className="form-label">Remarks</label>
                  <textarea
                    className="form-control"
                    {...register("remarks", {})}
                  ></textarea>
                  {errors.remarks && (
                    <small className="text-danger">
                      {errors.remarks.message}
                    </small>
                  )}
                </div>

                <div className="col-12">
                  <div className="d-flex gap-2 justify-content-end">
                    <button
                      className="btn btn-primary btn-sm"
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default WithdrawalConfirmationModal;
